import React from 'react'
import { typesOfData } from './classes/StatusItem'
import { ReactComponent as IconCar }  from '../../../../images/begtest/begtest-bil.svg'
import { ReactComponent as IconCheck }  from '../../../../images/begtest/bb-check_black.svg'
import { ReactComponent as IconExclamation }  from '../../../../images/begtest/bb-exclamation_red.svg'

function TyreDepthDisclaimer() {
  return (
    <div className="tyre-depth-disclaimer">
      <p>Helt nya sommardäck har ett mönsterdjup på 7-8 mm och vinterdäck 9-10 mm och lagen kräver att mönsterdjupet är minst 1,6 mm på sommardäck och minst 3 mm på vinterdäck för att man ska få köra med däcken</p>
    </div>
  )
}

function BegTestTyreColumn({ data }) {
  return (
    <div className="tyre-indicator-container">
      <div className="tyre-car">
          <IconCar />
      </div>

      {data.tyres.map(subData => (
        <div key={subData.position} className={`tyre tyre-${subData.position}`}>

          <div className="tyre-indicator">
              {
                  subData.result === 'OK'
                      ? <IconCheck/>
                      : <IconExclamation/>
              }
          </div>

          <div className={`tyre-result ${subData.result === 'OK' ? '' : 'text-warning'}`}>
            {subData.patternDepth}
          </div>
        </div>
      ))}
    </div>
  )
}

export default function BegTestTyresRow({ data }) {
  return (
    <li className="begtest-flex-container">
      {data
        .filter(subData => subData.itemType === typesOfData.tyreSets)
        .map(subData => (
          <div key={subData.key} className="container-item">
            <div className="title">{subData.type}</div>
              {subData.mounted && <div className="subtitle">Monterade</div>}

            <BegTestTyreColumn data={subData} />

            <div className="description">{subData.description}</div>
          </div>
        ))}
        <TyreDepthDisclaimer />
    </li>
  )
}